// extracted by css-extract-rspack-plugin
export default {"clinicCard":"clinicCard-WwcMMy"};